import ApiPagingRequestModel from '../../generated/types/model/resource/ApiPagingRequestModel';

export default class ApiPagingRequestViewModel extends ApiPagingRequestModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
